<template>
  <div class="content">
    <div class="header">
      <div class="tips">看清楚,想透彻,答准每道题</div>
      <div style="text-align: center;margin-top: 5px;" v-if="examInfo.exam_time">{{ times }}</div>
      <div class="subType">
        <span class="text"> {{ currItem.subject_group || examName }}</span>
      </div>
    </div>

    <div class="body">
      <div class="item" style="padding:10px">
        <div class="fs12 fwb">第{{ currIndex + 1 }}题<span class="ml10">({{ currItem.subject_type }})</span></div>
        <div class="question">
          {{ currItem.subject }}
        </div>
        <div class="answer">
          <van-checkbox-group @change="chooseCheckbox" v-model="currItem.userAnswer"
            v-if="currItem.subject_type == '多选题'">
            <van-checkbox shape="square" class="m10" :name="index" v-for="(item, index) in currItem.choose_list" :key="index">{{
              item
              }}</van-checkbox>
          </van-checkbox-group>
          <van-radio-group v-else @change="chooseRadio" v-model="currItem.userAnswer">
            <van-radio class="m10" :name="index" v-for="(item, index) in currItem.choose_list" :key="index">{{ item
              }}</van-radio>
          </van-radio-group>
        </div>
      </div>
    </div>
    <div class="footer">
      <van-button :disabled="currIndex == 0" type="danger" @click="prev">上一题</van-button>
      <van-button :disabled="currIndex == examInfo.subject_list?.length - 1" type="danger"
        @click="next">下一题</van-button>
      <van-button type="danger" @click="submit">提交试卷</van-button>
    </div>
  </div>

</template>

<script>
import { examListGet, examStart, examEnd } from '@/api/shopapi';
import moment from 'moment'
const NUMS = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"]
import _ from 'lodash';
const keyMap = {
  0: 'A',
  1: 'B',
  2: 'C',
  3: 'D',
  4: 'E',
  5: 'F',
  6: 'G',
  7: 'H',
  8: 'I'
}
let ttt = null
export default {
  data() {
    return {
      exam_id: '',
      mode: '',
      subject_count: '',
      currIndex: 0,
      currItem: {
        userAnswer: []
      },
      examInfo: {},
      result: [],
      times: '00:00',
      time: 0,
      t: null,
      isOk: false,
      examName: '',
      endTime: null,
      moment
    }
  },
  methods: {
    onChange(e) {
      this.result = e.detail
    },
    // 存储试卷
    saveTest() {
      // 考试才需要存
      if (this.mode == 1) {
        let ks = {
          currIndex: this.currIndex,
          examInfo: this.examInfo
        }
        localStorage.setItem('exam', JSON.stringify(ks))
      }
    },
    // 清除存储的试卷
    removeTest() {
      // 考试才需要删
      if (this.mode == 1) {
        localStorage.removeItem('exam')
      }
    },
    // 获取考试题目等信息
    startExam() {
      this.$toast.loading({ duration: 0, message: '加急获取试卷中...' })
      examStart({
        exam_id: this.exam_id,
        mode: this.mode,
        subject_count: this.subject_count
      }).then(res => {
        if (res.code == "000") {
          // res.data.subject_list.forEach(r => {
          //   r.an = null
          //   r.userAnswer = null
          // })
          this.examInfo = res.data
          this.currItem = res.data.subject_list[0]
          this.saveTest()
          this.cutDown()
          this.$toast.clear()
        } else {
          this.$toast.fail({ message: res.message })
        }
      })
    },
    // 单选选答案
    chooseRadio(e) {
      this.currItem['an'] = keyMap[e]
      this.saveTest()
    },
    // 多选选答案
    chooseCheckbox(e) {
      this.currItem['an'] = e.map(v => {
        return keyMap[v]
      }).join(',')
      this.saveTest()
    },
    // 下一题
    next() {
      if (this.currIndex >= this.examInfo.subject_list.length - 1) {
        this.$toast.fail({ message: '已经最后一题了' })
        return
      }

      // 判断当前这题是否选了
      if (!this.currItem.an) {
        this.$toast.fail({ message: '请选择答案' })
        return
      }
      this.currIndex += 1
      this.currItem = this.examInfo.subject_list[this.currIndex]
      this.saveTest()
    },
    // 上一题
    prev() {
      if (this.currIndex == 0) {
        this.$toast.fail({ message: '这是第一题' })
        return
      }
      this.currIndex -= 1
      this.currItem = this.examInfo.subject_list[this.currIndex]
      this.saveTest()
    },
    autoSubmit() {
      
      this.examInfo.errorCount = 0
      this.examInfo.totalScore = 0
      var result = []
      var sign = true
      this.examInfo.subject_list.forEach(v => {
        v.an = v.an?.split(',').sort().join().replace(/,/g, '')
        if (v.answer?.replace(/,/g, '') == v.an) {
          // 每题得分
          v.getScore = v.score
          //  总分
          this.examInfo.totalScore += v.score
        } else {
          //  得0分
          v.getScore = 0
          //  错误题数
          this.examInfo.errorCount++
        }
        // 判断在规定时间内是否全部答完
        if (!v.an && this.time > 0) {
          this.$toast.fail({ message: '您还有未答的题，完成后再交卷' })
          sign = false
        }
        result.push({
          answer: v.an?.split('').join(','),
          score: v.getScore,
          subject_id: v.subject_id
        })
      })
      // 还有时间的情况下有没填的直接拦截
      if (!sign) return
      //考试需要请求
      if (this.mode == 1) {
        // wx.showLoading({
        //   title: '交卷中...',
        // })
        examEnd({
          answer_list: result,
          id: Number(this.examInfo.id),
          user_score: this.examInfo.totalScore
        }).then(res => {
          if (res.code == "000") {
            // 清除缓存的试卷
            this.isOk = true
            this.removeTest()
            localStorage.setItem('examResult', JSON.stringify(this.examInfo))
            this.$router.replace('/examResult')
            this.$toast.success({ message: '提交成功' })
            clearInterval(ttt)
          } else {
            this.$toast.fail({ message: res.message })
            clearInterval(ttt)
          }
        }).catch(err => {
          this.$toast.fail({ message: err })
          clearInterval(ttt)
        })
      }
    },
    // 提交试卷
    submit() {
      this.$dialog.confirm({
        title: '提示',
        message: '是否要提交试卷？',
        confirmButtonText: '提交试卷',
        cancelButtonText: '再想想'
      }).then(() => {
        this.autoSubmit()
      }).catch(() => { })
    },
    // 计算倒计时
    // caculateCut() {
    //   var now = new Date().getTime()
    //   var start = new Date(this.examInfo.start_time).getTime() ? new Date(this.examInfo.start_time).getTime() : new Date(this.examInfo.start_time.replace(/-/g, '/')).getTime();
    //   // 开考到现在的时间
    //   var time_distance = (now - start) / 1000
    //   //考试结束时间减去现在时间，获得最大还剩几分钟的考试时间 
    //   // 考试时长减去已经开考了的时间，剩余考试时间，
    //   // this.examInfo.exam_time - time_distance   考试
    //   // 剩余考试时间（两者取最小值当做倒计时）
    //   if (this.endTime != null) {
    //     var a = new Date(this.endTime.replace(/-/g, '/')).getTime() - now
    //     var realTime = a / 1000
    //     console.log(1)
    //     this.time = Math.min((this.examInfo.exam_time - time_distance), realTime)
    //   } else { //考试存在持续考试，所有endTIme为null
    //     console.log(2, this.time, this.examInfo.exam_time, time_distance)
    //     this.time = this.examInfo.exam_time - time_distance
    //   }
    // },
    caculateCut() {
      const now = moment()
      let start = moment(this.examInfo.start_time).add(8, 'h')
      let time_distance = now.diff(start, 's')
      if (this.endTime !== null) {
        const realTime = moment(this.endTime).diff(moment(), 's')
        this.time = Math.min((moment(this.examInfo.exam_time).diff(time_distance), 's'), realTime)
      } else {
        this.time = moment(this.examInfo.exam_time).subtract(time_distance)
      }
    },
    // 考试倒计时
    cutDown() {
      if (this.examInfo.exam_time == 0) return //考试时长为0 ，即为无限制考试时间，所以不需要倒计时
      this.caculateCut()
      if (this.time > 0) {
        ttt = setInterval(() => {
          if (this.time > 0) {
            this.times = this.changeTime(this.time)
            this.caculateCut()
          } else {
            // 考试时间到
            this.$toast.fail({ message: '考试时间到，即将自动交卷' })
            var t1 = setTimeout(() => {
              this.autoSubmit()
              clearTimeout(t1)
            }, 1000);
            clearInterval(ttt)
          }
        }, 1000)
      } else {
        this.$toast.fail({ message: '考试时间到，即将自动交卷' })
        clearInterval(ttt)
        var t = setTimeout(() => {
          this.autoSubmit()
          clearTimeout(t)
        }, 1000);
      }
    },
    // 00:00形式
    changeTime(value) {
      var min = parseInt(value / 60).toString()
      var miao = parseInt(value % 60).toString()
      min = min[1] ? min : '0' + min
      miao = miao[1] ? miao : '0' + miao
      return min + ':' + miao
    }
  },
  destroyed(){
    clearInterval(ttt)
    clearInterval(this.t)
  },
  created() {
    const {
      id,
      count,
      mode,
      name,
      endTime
    } = this.$route.params
    this.exam_id = id
    this.mode = mode
    this.subject_count = count
    this.examName = name
    this.endTime = endTime
    var examCatch = localStorage.getItem('exam') ? JSON.parse(localStorage.getItem('exam')) : null
    if (examCatch && mode == 1) {
      this.examInfo = examCatch.examInfo
      this.currIndex = examCatch.currIndex
      this.currItem = this.examInfo.subject_list[this.currIndex]
      this.cutDown()
    } else {
      this.startExam()
    }
  }
}
</script>

<style scoped>
.main {
  width: 100%;
}

.content {
  width: 100%;
  z-index: 2;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  position: relative;
  background-color: #f6f6f6;
  overflow: scroll;
  flex: 1;
  display: block;
  font-size: 0.35rem;
}

.buttons-group {
  padding: 30px 0px;
  display: flex;
  justify-content: center;
}

.myButton {
  margin: 5px 20px;
}


.topDes {
  padding: 10px 26px;
}

.topDesHeader {
  color: #E7153A;
  font-weight: bolder;
  font-size: 20px;
  padding-bottom: 4px;
}

.topDesMsg {
  color: gray;
  font-size: 14px;
}



/* pages/wbSchool/examDetail/index.wxss */
.page {
  background-color: #f3f2f2;
  min-height: 100vh;
}

.header {
  padding: 0 40px;
  background-color: #fff;
}

.tips {
  color: #E7153A;
  font-weight: bold;
  font-size: 17px;
  text-align: center;
  padding: 10px 0;
}

.subType {
  text-align: center;
  padding: 5px;

}

.text {
  position: relative;
  box-sizing: border-box;
  padding: 5px;

}

.text:after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 20%;
  width: 60%;
  height: 3px;
  background-color: red;
}

.body {
  padding: 20px 15px;
}

.item {
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  padding: 15px 20px;
  border-radius: 5px;
}

.ml10 {
  margin-left: 5px;
}

.question {
  padding: 10px 0;
}

.footer {
  margin-top: 20px;
  display: flex;
  justify-content: space-around;
}

.m10 {
  margin: 8px 0;
  align-items: flex-start !important;
}

.van-radio__label {
  max-width: 88%;
}
</style>
